import styled from "styled-components";

import * as UI from "../../../../../../modules/ui-kit";
import SearchBait from "../../../components/SearchBait";

export const Button = styled.button`
    align-items: center;
    background: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    margin: 0;
    padding: 0;
    position: relative;

    svg {
        display: none;
        left: 100%;
        position: absolute;
    }

    &:hover {
        color: #889;

        svg {
            display: block;
            opacity: .5;
        }
    }

    &:active {
        color: #556;
    }
`;

export const Dialog = styled.dialog`
    border: none;
    border-radius: 8px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 32px;
    height: calc(100vh - 2 * 64px);
    left: calc(8vw + 16vw + 64px - 16px);
    padding: 0;
    position: fixed;
    top: 64px;

    &::backdrop {
        background: #0007;
    }

    body:has(&[open]) {
        overflow: hidden;
    }

    .close {
        left: calc(8vw + 16vw + 64px - 16px - 48px);
        top: 72px;
    }
`;

export const Filter = styled.div`
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    gap: 16px;

    & > span {
        font-size: 1.4rem;
        user-select: none;
    }
`;

export const Selection = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100%;
    padding: 16px;

    ${ SearchBait } {
        padding-left: 6px;
    }
`;

export const Table = styled(UI.Table)`
    tbody {
        tr {
            cursor: pointer;
        }

        th {
            svg {
                margin-right: 4px;
                vertical-align: middle;
            }

            span {
                font-weight: normal;
                opacity: .5;

                &::before {
                    content: " ";
                }
            }
        }
    }
`;
